import InterlinkBlock from './components/InterlinkBlock';

export default InterlinkBlock;
